export default __webpack_public_path__ + "static/media/cert-market-HKIRC.366e8073.jpg";